import React, { useState } from "react";
import {NavLink, useNavigate, useLocation} from "react-router-dom";

const Navbar = props => {
    const onClickScroll = (navItem)=>{
        const element = document.getElementById(navItem);
        element.scrollIntoView({behavior: 'smooth'});
    }
    const navigate = useNavigate()
    const { pathname } = useLocation();
    const logout = ()=>{
        sessionStorage.removeItem('token')
        navigate('/logout')
    }
    return (
        <>
            {props.isMenuOpen && (
            <nav className={`navbar ${props.isMenuOpen ? 'navbar-show' : ''}`}>
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <div className={`nav-link ${pathname === "/vehicle" ? "active" : ""}`} onClick={()=>{navigate('/vehicle')}}>
                            Vehicles
                        </div>
                    </li>
                    <li className="nav-item">
                        <div className={`nav-link ${pathname === "/payments" ? "active" : ""}`} onClick={()=>{navigate('/payments')}}>
                        Wallet
                        </div>
                    </li>
                    <li className="nav-item">
                        <div className={`nav-link ${pathname === "/profile" ? "active" : ""}`} onClick={()=>{navigate('/profile')}}>
                            Profile
                        </div>
                    </li>
                    <li className="nav-item">
                        <div className='nav-link' onClick={logout}>
                            Logout
                        </div>
                    </li>
                </ul>
            </nav>
            )}
        </>
    )
}

export default Navbar;
